function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.626,
    height: 28,
    viewBox: "0 0 27.626 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame_1",
    "data-name": "Frame 1",
    transform: "translate(0 0.167)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_1-2",
    "data-name": "Frame 1",
    width: 27,
    height: 28,
    transform: "translate(0.626 -0.167)",
    fill: "none",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "icMenu",
    transform: "translate(0 2.007)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "bar",
    d: "M21.213,0a1.72,1.72,0,1,1,0,3.44H1.72A1.72,1.72,0,1,1,1.72,0Z",
    transform: "translate(0 0)",
    fill: "#f28a3a",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "bar-2",
    "data-name": "bar",
    d: "M21.213,0a1.72,1.72,0,1,1,0,3.44H1.72A1.72,1.72,0,1,1,1.72,0Z",
    transform: "translate(0 18.347)",
    fill: "#f28a3a",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "bar-3",
    "data-name": "bar",
    d: "M21.213,0a1.72,1.72,0,1,1,0,3.44H1.72A1.72,1.72,0,1,1,1.72,0Z",
    transform: "translate(4.587 9.173)",
    fill: "#f28a3a",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu_icon.07691059cb030585b4caaf44cdb2803e.svg";
export { ForwardRef as ReactComponent };